/* eslint-disable */

const Team = el => {
	const cards = document.querySelectorAll('.filters-result .item');
	const inputs = document.querySelectorAll('.filters input');
	const filter_tag = document.querySelector('.filters-tag');
	const filter_cat = document.querySelectorAll('.filters-category');
	const reset = document.querySelector('.filters-reset');
	
	var keywords_selected = [];
	var keywords_selected_ou = [];
	var cat_selected;
	var filter_cat_secected;

	const open = () => {
		window.addEventListener('click', close,true);
	}
	const close = e => {
		if(!filter_cat_secected.contains(e.target)){
			filter_cat.forEach(el => el.classList.remove('open'));
			window.removeEventListener('click', close);
		}
	}

	filter_cat.forEach(el => {
		el.onmouseup = e => {
			e.stopPropagation();
			filter_cat.forEach(el1 => el1 !== el && el1.classList.remove('open'));
			filter_cat_secected = el;
			el.classList.toggle('open');
			el.classList.contains('open') && open();
		}
	});

	const disable = () => {
		var keywords = [];
		var str = '';
		cards.forEach(card => {
			if(card.style.display === 'block'){
				if(card.dataset.filterJob) str += card.dataset.filterJob + ",";
				if(card.dataset.filterFunction) str += card.dataset.filterFunction + ",";
				if(card.dataset.filterSector) str += card.dataset.filterSector + ",";
			}
		});
		keywords = str.split(',');
		keywords.pop();
		const dataArrWithSet = new Set(keywords);
		const arr = [...dataArrWithSet];
		inputs.forEach(input => {
			if(input.closest('.filters-category').dataset.cat != cat_selected){
				if(arr.includes(input.value) || arr.length == 0) input.disabled = false;
				else input.disabled = true;
			}
		});
	}

	const filter = () => {
		el.scrollIntoView({behavior: 'smooth'});
		var inc = 0;
		cards.forEach((item, i) => {
			item.style.display = 'none';
			item.style.animation = 'none';
			item.offsetHeight; /* trigger reflow */
			item.style.animation = null;
			
			var ok = true;
			keywords_selected.forEach(keyword => {
				const filterString = `${item.dataset.filterJob} ${item.dataset.filterFunction} ${item.dataset.filterSector}`;
				if(filterString.indexOf(keyword) == -1) ok = false;
			})

			var dd0 = 0;
			var dd1 = 0;
			var dd2 = 0;
			keywords_selected_ou.forEach(keyword => {
				const filterString = `${item.dataset.filterJob}`;
				if(filterString.indexOf(keyword) !== -1) dd0 = 1;
			})
			keywords_selected_ou.forEach(keyword => {
				const filterString = `${item.dataset.filterFunction}`;
				if(filterString.indexOf(keyword) !== -1) dd1 = 1;
			})
			keywords_selected_ou.forEach(keyword => {
				const filterString = `${item.dataset.filterSector}`;
				if(filterString.indexOf(keyword) !== -1) dd2 = 1;
			})

			/*console.log('------------------------');
			console.log(ok, keywords_selected);
			console.log(keywords_selected_ou);
			console.log(dd0,dd1,dd2);

			console.log('------------------------');*/

			/*if(dd == keywords_selected_ou.length && ok == true){
				item.style.display = 'block';
				item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
				inc++;
			}*/
			/*if(dd >= 1 && ok == true){
				item.style.display = 'block';
				item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
				inc++;
			}*/
			if(ok == true && keywords_selected_ou.length == 0){
	
					item.style.display = 'block';
					item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
					inc++;
			
		
			}

			if(ok == true && keywords_selected_ou.length >= 1){

				if(dd0 == 1){
					item.style.display = 'block';
					item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
					inc++;
				}
				if(dd1 == 1){
					item.style.display = 'block';
					item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
					inc++;
				}
				if(dd2 == 1){
					item.style.display = 'block';
					item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
					inc++;
				}

			}

			if(keywords_selected.length == 0 && keywords_selected_ou.length == 0){
				item.style.display = 'block';
				item.style.animation = `itemDisplay .6s ease ${inc * .15}s both`;
				inc++;
			}
		});
	}

	const tags = (val, name) => {
		const tag = document.createElement('button');
		tag.className = 'btn-tag';
		tag.innerHTML = name;
		tag.value = val;
		filter_tag.appendChild(tag);
		tag.onclick = () => {
			inputs.forEach(input => {
				if(input.value == tag.value) input.checked = false;
			})
			change();
		}
	}

	const change = () => {
		keywords_selected = [];
		keywords_selected_ou = [];
		filter_tag.innerHTML = "";
		inputs.forEach(el => {
			if(el.checked === true && !el.classList.contains('hasChildren')){
				tags(el.value, el.dataset.name);
				if(el.classList.contains('children')) keywords_selected_ou.push(el.value);
				else  keywords_selected.push(el.value);
			}
			if(el.checked === false){
				el.classList.remove('active');
				if(el.classList.contains('hasChildren')){
					el.parentNode.querySelectorAll('input').forEach(tt => {
						tt.checked = false;
					});
				}
			}
		})
		filter();
		disable();
	}

	inputs.forEach(input => {
		input.checked = false;
		input.classList.remove('active')
		input.onclick = () => {
			const hasChildren = input.classList.contains('hasChildren');
			cat_selected = input.closest('.filters-category').dataset.cat;
			if(!input.classList.contains('active')){
				
				if(hasChildren){
					//var ff = input.parentNode.querySelectorAll('.filters-children input');
					input.parentNode.querySelectorAll('ul input').forEach(el=>{
						el.checked = true;
					});
				}
				if(input.classList.contains('children')){
					const childrens = input.parentNode.parentNode.querySelectorAll('.children');
					var allchecked = 0;
					childrens.forEach((child)=>{
						if(child.checked === true){
							allchecked++;
						}
					});
					input.parentNode.parentNode.parentNode.querySelector('.hasChildren').classList.add('active');
					input.parentNode.parentNode.parentNode.querySelector('.hasChildren').checked = true;
					if(!allchecked){
						input.parentNode.parentNode.parentNode.querySelector('.hasChildren').classList.remove('active');
						input.parentNode.parentNode.parentNode.querySelector('.hasChildren').checked = false;
					}
					
				}else{
					input.classList.add('active');
				}
				change();
			}
	   }
	})

	reset.onclick = () => {
		keywords_selected = [];
		keywords_selected_ou = [];
		filter_tag.innerHTML = "";
		inputs.forEach(el => {
			el.checked = false;
			el.disable = false;
			el.classList.remove('active');
		})
		filter();
		inputs.forEach(input => {input.disabled = false});
	}
}

export default Team;